import { Link } from "react-router-dom";
import LogoMark from "./LogoMark";
import { useAuth } from "../../context/AuthContext";

const defaultLinks = [
  { href: "/how", label: "How it works" },
  { href: "/books", label: "The Book" },
  { href: "#receipts", label: "Receipts" },
  { href: "#pricing", label: "Pricing" },
];

export default function Nav({ links = defaultLinks }) {
  const { user } = useAuth();
  const authed = !!user && user !== false;
  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 border-b border-[rgba(255,255,255,0.06)] bg-[rgba(11,14,20,0.88)] backdrop-blur-md">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link
            to="/"
            data-testid="nav-logo"
            className="flex items-center gap-2.5"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <LogoMark className="h-7 w-auto" />
            <span className="text-[17px] font-bold tracking-tight text-[#E8EBF0]">fundprints</span>
          </Link>
          <nav className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href.startsWith("#") ? l.href : l.href}
                data-testid={`nav-link-${l.href.slice(1) || "home"}`}
                onClick={(e) => {
                  if (!l.href.startsWith("#")) return;
                  e.preventDefault();
                  const el = document.getElementById(l.href.slice(1));
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                  else window.location.href = `/${l.href}`;
                }}
                className="text-sm text-[#8B93A3] hover:text-[#E8EBF0] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            {authed ? (
              <>
                <Link
                  to="/app/account"
                  data-testid="nav-account-link"
                  className="hidden sm:block text-sm text-[#8B93A3] hover:text-[#E8EBF0] transition-colors"
                >
                  Account
                </Link>
                <Link
                  to="/app"
                  data-testid="nav-my-holdings-btn"
                  className="fp-btn text-sm px-4 py-2"
                >
                  My Holdings →
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  data-testid="nav-login-link"
                  className="text-sm text-[#8B93A3] hover:text-[#E8EBF0] transition-colors"
                >
                  Log in
                </Link>
              </>
            )}
          </div>
        </div>
      </header>
      <div className="h-16" aria-hidden="true" />
    </>
  );
}
